export const INIT_STATE = 'INIT_CLIENT_LIST_STATE';

export const GET_CLIENT_LIST_LOADING = 'GET_CLIENT_LIST_LOADING';
export const GET_CLIENT_LIST_SUCCESS = 'GET_CLIENT_LIST_SUCCESS';
export const GET_CLIENT_LIST_ERROR = 'GET_CLIENT_LIST_ERROR';